import React from 'react';
import styles from './styles';
import {DragTableContext} from '../Utils/DragTableContext';
import {InOutAnimation as Animation} from '@xpertdox_js/xdcomponents';

const Scrollbar = props => {
  const {scrollbarMouseDownEvent, mouseUpEvent, dragEvent, dragHover, scrollbarValue} = React.useContext(DragTableContext);

  const width = parseInt(props.scrollbarWidth);
  return(
    <Animation
      animation={{
        in: [
          ['opacity', {0: 0, 100: .5}, 280]
        ],
        out: [
          ['opacity', {0: .5, 100: 0}, 280]
        ]
      }}
      condition={dragHover}
      wrapStyles={{...styles.scrollbarContainer, width: props.scrollbarWidth}}
      alwaysRender
    >
      <div
        onMouseDown={scrollbarMouseDownEvent}
        onMouseUp={mouseUpEvent}
        style={{width: '100%', height: '100%', position: 'absolute'}}
      >
        <div
          style={{
            ...styles.scrollbar,
            width: width - (props.controller.headersTotalWidth - width),
            transform: `translateX(${'-' + scrollbarValue})`,
            left: scrollbarValue
          }}
          id={props.controller.tableID + '_scrollbar'}
        >
        </div>
      </div>
    </Animation>
  )
}

export default Scrollbar;
